import React from 'react'

const CapabilityCheckIcon = (
  <path
    d="M1.59961 8.37036L5.86628 12.7407L14.3996 4"
    fill="none"
    stroke="#37A598"
    strokeWidth="1.33333"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
)

export default CapabilityCheckIcon
